const SERVICES = [
  {
    name: "Telegram (Ex-bank)",
    code: "telegram",
    short: "telegram",
    id: "t",
    color: "#3bb4d2",
  },
  {
    name: "Telegram (Ex-bank v2)",
    code: "telegram_v2",
    short: "telegram_v2",
    id: "t2",
    color: "#3bb4d2",
  },
];

export default SERVICES;
